module.exports = __webpack_public_path__ + "img/Orsted_RGB_White.79792f44.png";